import { useRefreshCandidate } from "#candidate/redux/actions"
import { useCandidateRedux } from "#candidate/redux/slice"
import { candidateIdPut } from "#candidate/services/api"
import InputNumber from "#core/components/input/number/InputNumber"
import { useApiSend } from "#hooks/useApiSend"
import CheckBoxIcon from "@mui/icons-material/CheckBox"
import EditIcon from "@mui/icons-material/Edit"
import { Button, Stack, TextField } from "@mui/material"
import { useCallback, useState } from "react"

export const CandidateEditFields = ({ id, label, datum, number }) => {
	const { candidateId } = useCandidateRedux()
	const [edit, setEdit] = useState(false)
	const [value, setValue] = useState(datum)
	const [disable, setDisable] = useState(false)
	const { refresh } = useRefreshCandidate()

	const success = () => {
		refresh()
	}
	const end = () => {
		setDisable(false)
	}

	const { fetch } = useApiSend(candidateIdPut, { success, end })
	const handleFetch = useCallback(() => {
		setDisable(true)
		fetch(candidateId, { [id]: value })
	}, [fetch, candidateId, id, value])

	let button = (
		<Button onClick={() => setEdit(true)}>
			<EditIcon />
		</Button>
	)
	if (edit) {
		button = (
			<Button onClick={handleFetch} disabled={disable}>
				<CheckBoxIcon />
			</Button>
		)
	}
	const Field = number ? InputNumber : TextField

	return (
		<Stack spacing={2} direction={"row"} alignItems={"center"} width={"100%"}>
			<Field
				{...{ label, value }}
				disabled={!edit}
				onChange={(e) => setValue(e.target.value)}
				fullWidth
			/>
			{button}
		</Stack>
	)
}
